import { configureStore } from "@reduxjs/toolkit";
import userReducer from "./userSlice";
import influencersReducer from "./allInfluencersSlice";

const appStore = configureStore({
  reducer: {
    user: userReducer,
    influencers: influencersReducer,
  },
});

export default appStore;
